import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLocalization } from '../../contexts/LocalizationContext';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PaymentFailurePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { language } = useLocalization();

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleGoBack = () => {
    navigate('/subscription');
  };

  const handleRetry = () => {
    // Get the plan ID from the URL or session storage
    const planId = searchParams.get('planId') || 'professional';
    navigate(`/payment/${planId}`);
  };

  const sessionId = searchParams.get('session_id');
  const error = searchParams.get('error') || searchParams.get('message');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          {language === 'ar' ? 'فشل الدفع' : 'Payment Failed'}
        </h2>
        <p className="text-lg text-gray-600 mb-6">
          {language === 'ar' 
            ? 'عذراً، لم يتم إتمام عملية الدفع بنجاح. يرجى المحاولة مرة أخرى.'
            : 'Sorry, your payment could not be completed successfully. Please try again.'
          }
        </p>
        
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-red-800 text-sm">
              <strong>{language === 'ar' ? 'الخطأ:' : 'Error:'}</strong> {error}
            </p>
          </div>
        )}
        
        {sessionId && (
          <p className="text-sm text-gray-500 mb-6">
            {language === 'ar' ? 'رقم الجلسة:' : 'Session ID:'} {sessionId}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleGoBack}
            className="flex items-center justify-center space-x-2 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>{language === 'ar' ? 'العودة' : 'Go Back'}</span>
          </button>
          
          <button
            onClick={handleRetry}
            className="flex items-center justify-center space-x-2 px-6 py-3 bg-accent text-white rounded-lg font-semibold hover:bg-accent-dark transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            <span>{language === 'ar' ? 'المحاولة مرة أخرى' : 'Try Again'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailurePage;
